import {
    BreadcrumbsWrapper,
    CompanyLogoWrapper,
    HeaderContainer,
    StyledIcon,
    StyledIconButton,
} from './TopHeader.styles';
import UserPreview from '../UserPreview';
import Breadcrumbs from './Breadcrumbs';
import CompanyLogo from './CompanyLogo';
import { userSelectors } from '../../../actions';
import { useAppSelector, Theme, Box, useTheme } from '../../../base';
import { useMediaQuery } from '@mui/material';

const TopHeader = () => {
    const isMobile = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('md')
    );
    const myUser = useAppSelector(userSelectors.getMyUser);
    const theme = useTheme();

    return (
        <HeaderContainer sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                <BreadcrumbsWrapper>
                    <Breadcrumbs />
                </BreadcrumbsWrapper>
                <CompanyLogoWrapper>
                    <CompanyLogo />
                </CompanyLogoWrapper>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {!isMobile && (
                    <>
                        {/* <StyledIconButton
                            edge="end"
                            size="small"
                            onClick={() => {}}
                        >
                            <StyledIcon name={'NotificationsIcon'} size={28} />
                        </StyledIconButton> */}
                        <StyledIconButton
                            edge="end"
                            size="small"
                            onClick={() => {
                                window.open(
                                    `/positions?ck=${myUser?.company?.key}`,
                                    '_blank',
                                    'noopener,noreferrer'
                                );
                            }}
                            sx={{ marginInlineEnd: theme.spacing(1) }}
                        >
                            <StyledIcon name={'GridViewIcon'} size={28} />
                        </StyledIconButton>
                        <UserPreview />
                    </>
                )}

                {/* Mobile: Render *only* the original Grid button */}
                {isMobile && (
                    <StyledIconButton
                        edge="end"
                        size="small"
                        onClick={() => {
                            window.open(
                                `/positions?ck=${myUser?.company?.key}`,
                                '_blank',
                                'noopener,noreferrer'
                            );
                        }}
                    >
                        <StyledIcon name={'GridViewIcon'} size={28} />
                    </StyledIconButton>
                )}
            </Box>
        </HeaderContainer>
    );
};

export default TopHeader;
